import { get, patch, post, del, put } from "src/services/api";

export const fetchAssistant = async (params) => {
  const endpoint = `/accounts/${params.accountId}/assistants/${params.assistantId}`;
  return await get({ endpoint });
};

export const fetchTemplates = async (params, isAccountPage) => {
  const endpoint = isAccountPage ? "assistants/templates" : "v2/admin/assistants/templates";
  return await get({ endpoint, params });
};

export const fetchAvailableData = async (params, isAccountPage) => {
  const endpoint = isAccountPage ? "assistants/config" : "v2/admin/assistants/config";
  return await get({ endpoint, params });
};

const fetchLanguages = async (params) => {
  const endpoint = `/accounts/${params.selectedAccountId}/assistants/${params.selectedAssistantId}/languages`;
  return await get({ endpoint });
};

export const fetchSupportedLanguages = async (isAccountPage) => {
  const endpoint = isAccountPage ? "assistants/languages" : "v2/admin/assistants/languages";
  return await get({ endpoint });
};

export const fetchVerticalTypes = async (isAccountPage) => {
  const endpoint = isAccountPage ? "assistants/vertical-types" : "v2/admin/assistants/vertical-types";
  return await get({ endpoint });
};

export const fetchDefaultSettings = async (params, isAccountPage) => {
  const endpoint = isAccountPage ? `assistants/default-settings?channel=${params.assistantChannel}` : `v2/admin/assistants/default-settings?channel=${params.assistantChannel}`;
  return await get({ endpoint });
};

export const fetchDraft = async (accountId, assistantId) => await get({
  endpoint: `/account/${accountId}/assistant/${assistantId}/draft`
});

export const fetchAllAssistantsData = async () => await get({ endpoint: "assistants" });

export const createCodelessAssistant = async (data, extraData, isAccountPage) => {
  const endpoint = isAccountPage ? `accounts/${extraData.accountId}/assistants` : "v2/admin/assistants";
  return await post({ endpoint, data, headers: { pageName: extraData.pageName } });
};

export const setAssistantLive = async (data) => {
  const { pageName } = data;
  const endpoint = `accounts/${data.accountId}/assistants/v2/${data.assistantId}/set-live`;
  return await patch({ endpoint, headers: { pageName } });
};

export const disableAgent = async (data) => {
  const { pageName } = data;
  const endpoint = `accounts/${data.accountId}/assistants/${data.assistantId}/deactivate`;
  return await patch({ endpoint, headers: { pageName } });
};

export const resetAssistant = async (data) => {
  const { pageName } = data;
  const endpoint = `accounts/${data.accountId}/assistants/${data.assistantId}/reset`;
  return await patch({ endpoint, headers: { pageName } });
};

export const archiveAssistant = async (data) => {
  const { pageName } = data;
  const endpoint = `accounts/${data.accountId}/assistants/${data.assistantId}/archive`;
  return await del({ endpoint, headers: { pageName } });
};

export const duplicateAssistant = async (data) => {
  const { pageName, accountId, ...reqData } = data;
  const endpoint = `accounts/${data.accountId}/assistants/${data.assistantId}/duplicate`;
  return await post({ endpoint, data: reqData, headers: { pageName } });
};

export const initiateCall = async (data) => {
  const { pageName, assistantId, accountId, ...rest } = data;
  const endpoint = `accounts/${accountId}/assistants/${assistantId}/initiateCall`;
  return await post({ endpoint, data: rest, headers: { pageName } });
};

export const fetchCallMeSites = async (assistantId, mode) => {
  const endpoint = `/v2/assistants/collections/${assistantId}/call-me/sites`;
  return await get({ endpoint, params: { mode } });
};

export const fetchCallMeBusinessHours = async (assistantId, mode) => {
  const endpoint = `/v2/assistants/collections/${assistantId}/call-me/business-hours`;
  return await get({ endpoint, params: { mode } });
};

export const findConnector = async (data) => {
  const { pageName, assistantId, accountId, connectorType } = data;
  const endpoint = `accounts/${accountId}/assistants/${assistantId}/findConnector?connectorType=${connectorType}`;
  return await get({ endpoint, headers: { pageName } });
};

export const fetchAgentKnowledge = async (assistantId) => {
  const endpoint = `assistants/${assistantId}/config/knowledge`;
  return await get({ endpoint });
};

export const updateAgentKnowledge = async (assistantId, mode, knowledgeData) => {
  const endpoint = `assistants/${assistantId}/config/knowledge/${mode}`;
  return await put({ endpoint, data: { knowledge: knowledgeData } });
};

export const fetchAgentConfiguration = async (assistantId) => {
  const endpoint = `assistants/${assistantId}/config/configuration`;
  return await get({ endpoint });
};

export const fetchConfigId = async (assistantId, mode) => {
  const endpoint = `assistants/${assistantId}/config/${mode}/id`;
  return await get({ endpoint });
};

export const saveSkillConfiguration = async ({ assistantId, skillSpecKey, skillInstanceKey, payload }) => {
  const endpoint = `v2/assistants/collections/${assistantId}/skills/${skillSpecKey}/${skillInstanceKey}`;
  return await put({ endpoint, data: payload });
};

export const getAssistantFile = async (assistantId) => {
  const endpoint = `assistants/${assistantId}/config/download`;
  return await get({ endpoint });
};

export const uploadAssistantConfig = async (file, name, accountId) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("name", name);
  if (accountId) {
    formData.append("accountId", accountId);
  }
  const endpoint = "assistants/config/upload";
  return await post({
    endpoint,
    data: formData,
    headers: { "Content-Type": "multipart/form-data" }
  });
};

export const fetchChannelSettings = async ({ accountId, assistantId, signal }) => {
  const endpoint = `accounts/${accountId}/assistants/${assistantId}/settings`;
  return await get({ endpoint, signal });
};

export default {
  fetchAssistant,
  fetchTemplates,
  fetchAvailableData,
  fetchLanguages,
  fetchSupportedLanguages,
  fetchDefaultSettings,
  fetchVerticalTypes,
  fetchAllAssistantsData,
  setAssistantLive,
  disableAgent,
  resetAssistant,
  archiveAssistant,
  duplicateAssistant,
  initiateCall,
  findConnector,
  fetchAgentKnowledge,
  updateAgentKnowledge,
  fetchAgentConfiguration,
  fetchConfigId,
  saveSkillConfiguration,
  getAssistantFile,
  uploadAssistantConfig,
  fetchChannelSettings,
  fetchCallMeSites,
  fetchCallMeBusinessHours
};
